var map = {
	"./apin/locales/en.json": 81073,
	"./apin/locales/pt.json": 44350,
	"./cadaval/locales/en.json": 72687,
	"./cadaval/locales/pt.json": 32528,
	"./fcolmeiasememoria/locales/en.json": 17023,
	"./fcolmeiasememoria/locales/pt.json": 25280,
	"./oaz/locales/en.json": 48843,
	"./oaz/locales/pt.json": 56596,
	"./oeiraseu/locales/en.json": 51200,
	"./oeiraseu/locales/pt.json": 81651,
	"./proenca/locales/en.json": 62913,
	"./proenca/locales/pt.json": 39726,
	"./rgrande/locales/en.json": 35272,
	"./rgrande/locales/pt.json": 53675,
	"./rnps/locales/en.json": 19568,
	"./rnps/locales/pt.json": 80387,
	"./vcambra/locales/en.json": 85253,
	"./vcambra/locales/pt.json": 48394,
	"src/configuration/platforms/apin/locales/en.json": 81073,
	"src/configuration/platforms/apin/locales/pt.json": 44350,
	"src/configuration/platforms/cadaval/locales/en.json": 72687,
	"src/configuration/platforms/cadaval/locales/pt.json": 32528,
	"src/configuration/platforms/fcolmeiasememoria/locales/en.json": 17023,
	"src/configuration/platforms/fcolmeiasememoria/locales/pt.json": 25280,
	"src/configuration/platforms/oaz/locales/en.json": 48843,
	"src/configuration/platforms/oaz/locales/pt.json": 56596,
	"src/configuration/platforms/oeiraseu/locales/en.json": 51200,
	"src/configuration/platforms/oeiraseu/locales/pt.json": 81651,
	"src/configuration/platforms/proenca/locales/en.json": 62913,
	"src/configuration/platforms/proenca/locales/pt.json": 39726,
	"src/configuration/platforms/rgrande/locales/en.json": 35272,
	"src/configuration/platforms/rgrande/locales/pt.json": 53675,
	"src/configuration/platforms/rnps/locales/en.json": 19568,
	"src/configuration/platforms/rnps/locales/pt.json": 80387,
	"src/configuration/platforms/vcambra/locales/en.json": 85253,
	"src/configuration/platforms/vcambra/locales/pt.json": 48394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55637;